import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import type { Provider } from '@repo/api-gw-sdk';
import { KmsCopyablePolicy } from './kmsCopyablePolicy';
import { KmsEditKeyPolicyButton } from './kmsEditKeyPolicyButton';
export const KmsSuggestedPolicyContent = t0 => {
  const $ = _c(9);
  const {
    kmsKey,
    cloudProvider,
    withRestoreAccounts: t1
  } = t0;
  const withRestoreAccounts = t1 === undefined ? true : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      paddingX: "40px",
      gap: "24px",
      alignItems: "flex-end"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== cloudProvider || $[2] !== withRestoreAccounts) {
    t3 = <KmsCopyablePolicy cloudProvider={cloudProvider} withRestoreAccounts={withRestoreAccounts} />;
    $[1] = cloudProvider;
    $[2] = withRestoreAccounts;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== kmsKey) {
    t4 = <KmsEditKeyPolicyButton kmsKey={kmsKey} />;
    $[4] = kmsKey;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <Stack sx={t2}>{t3}{t4}</Stack>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};